export function getDateXDaysAgo(numOfDays: number, date = new Date()): Date {
  const daysAgo = new Date(date.getTime())

  daysAgo.setDate(date.getDate() - numOfDays)

  return daysAgo
}
